import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { AlertIdBox } from "@/components/molecules/AlertIdBox";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useLocation, useNavigate } from "react-router";

export const CheckIdPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};
  return (
    <MainTemplate nav={false} subPage={false} menuBtn={false}>
      <Form
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="로그인하기"
            onClick={() => navigate("/auth/login")}
          />
        }
      >
        <AlertIdBox data={userData.userId} />
      </Form>
    </MainTemplate>
  );
};
